import { useTranslation } from 'react-i18next'
import isEmpty from 'lodash-es/isEmpty'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import Button from '../../Button'
import { Buttons } from '../../Modal'
import { MoreActionsButton } from '../../MoreActionsButton'

function FilterModalActions({
  canViewFilterTemplate,
  editingOptions,
  filterOptions,
  isEditing,
  isLoading,
  onCancel,
  onClear,
  onDelete,
  onReplaceTemplate,
  onSaveTemplate,
  onSubmit,
}) {
  const { t } = useTranslation()

  const secondaryActions = [
    ...(!isEmpty(editingOptions) || !isEmpty(filterOptions)
      ? [
          {
            Component: Button.Flat,
            height: 40,
            isGrey: true,
            key: 'clear',
            text: t('Modal.ClearFilterBtnKey'),
            tooltip: t('Modal.ClearFilterBtnTooltipKey'),
            tooltipPlacement: FLOATING_ELEMENT_PLACEMENT.top,
            onClick: onClear,
          },
          ...(!isEmpty(filterOptions) && canViewFilterTemplate
            ? [
                {
                  Component: Button.Flat,
                  height: 40,
                  isGrey: true,
                  key: 'save-template',
                  text: t('Modal.SaveFilterAsTemplateBtnKey'),
                  onClick: onSaveTemplate,
                },
                {
                  Component: Button.Flat,
                  height: 40,
                  isGrey: true,
                  key: 'replace-template',
                  text: t('Modal.ReplaceFilterTemplateBtnKey'),
                  onClick: onReplaceTemplate,
                },
              ]
            : []),
        ]
      : []),
    ...(isEditing
      ? [
          {
            Component: Button.Flat,
            height: 40,
            isGrey: true,
            key: 'delete',
            text: t('Modal.DeleteFilterTemplateBtnKey'),
            onClick: onDelete,
          },
        ]
      : []),
  ]

  return (
    <Buttons size='l'>
      <Button.Contained
        isLoading={isLoading}
        text={t(isEditing ? 'Modal.SaveBtnKey' : 'Modal.ApplyFilterBtnKey')}
        type='submit'
        onClick={onSubmit}
      />
      <Button.Outlined
        text={t('Modal.CancelBtnKey')}
        tooltip={t('Modal.CancelBtnTooltipKey')}
        tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
        onClick={onCancel}
      />
      {secondaryActions.length > 0 ? (
        <MoreActionsButton
          actions={secondaryActions}
          disabled={isLoading}
          text={t('Common.More')}
        />
      ) : null}
    </Buttons>
  )
}

export default FilterModalActions
